import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Mona_Sans, IBM_Plex_Mono } from 'next/font/google'

// Mona Sans carries the whole type system: its width axis runs headings wide (stretch-wide) and body copy at normal width.
const sans = Mona_Sans({
    subsets: ['latin'],
    axes: ['wdth']
})

// IBM Plex Mono is reserved for small labels, indices and figure captions.
const mono = IBM_Plex_Mono({
    subsets: ['latin'],
    weight: ['400', '500']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${sans.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App
